// Settings that belong to this browser only (not to the user's account):
// kept in localStorage. Storage can be missing or throw (private windows,
// blocked site data), so every read has a default and every write may fail.

export type DeviceFlag =
  /** "Not now" on the call alerts card */
  | 'alertsNotNow'
  /** the "call alerts are blocked" banner was hidden */
  | 'alertsBlockedHidden'
  /** Settings → Advanced: always connect calls through the CloudPhone relay */
  | 'relayAlways';

const KEY: Record<DeviceFlag, string> = {
  alertsNotNow: 'cloudphone.alerts.notNow',
  alertsBlockedHidden: 'cloudphone.alerts.blockedHidden',
  relayAlways: 'cloudphone.relayAlways',
};

export function getFlag(flag: DeviceFlag): boolean {
  try {
    return globalThis.localStorage?.getItem(KEY[flag]) === '1';
  } catch {
    return false;
  }
}

export function setFlag(flag: DeviceFlag, on: boolean): void {
  try {
    if (on) globalThis.localStorage?.setItem(KEY[flag], '1');
    else globalThis.localStorage?.removeItem(KEY[flag]);
  } catch {
    /* not saved: it applies until the page is reloaded */
  }
}
